import React from 'react';
import StyledChip from './StyledChip';

export default function PoolItem({
  pool,
  onViewPool
}: {
  pool: { id: number; title: string };
  onViewPool?: (poolId: number) => void;
}) {
  return <StyledChip onClick={() => onViewPool && onViewPool(pool.id)}>{pool.title}</StyledChip>;
}
